import { render, staticRenderFns } from "./courseCell.vue?vue&type=template&id=341d4bae&scoped=true"
import script from "./courseCell.vue?vue&type=script&lang=ts"
export * from "./courseCell.vue?vue&type=script&lang=ts"
import style0 from "./courseCell.vue?vue&type=style&index=0&id=341d4bae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341d4bae",
  null
  
)

export default component.exports